import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import MDTypography from "components/Basics/MDTypography";
import MDButton from "components/Basics/MDButton";
import { t } from "i18next";

/**
 * Dialog to confirm analyse conversation light action
 * @param {boolean} open - If the dialog is open or not
 * @param {function} onClose - Function to call to close the dialog
 * @param {function} perform - Function to call to perform the action
 * @param {object} resource - The resource on which we want to scrap reviews
 * @param {object} action - The action to perform
 * @param {object|array} values - The values on which we want to perform the action
 * @returns {JSX.Element} - The dialog component
 */
const AnalyseConversationLight = ({ open, onClose, perform, resource, action, values }) => {
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>{t("FORMS.RESOURCE.analyseConversationLightTitle")}</DialogTitle>
			<DialogContent>
				<MDTypography variant="subtitle2" color="text">
					{t("FORMS.RESOURCE.analyseConversationLightDescription")}
				</MDTypography>
			</DialogContent>
			<DialogActions>
				<MDButton variant="outlined" color="info" onClick={onClose}>
					{t("SETTINGS.cancel")}
				</MDButton>
				<MDButton
					variant="contained"
					color="info"
					onClick={() => {
						const safeValues = Array.isArray(values) ? values : [values];
						perform(action, safeValues);
						onClose();
					}}
				>
					{t("SETTINGS.confirm")}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
};

export default AnalyseConversationLight;
